import React, { useEffect, useState } from 'react'
import { Accordion, Col, Row, Table } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import { useAuth } from '../../context/ContextData';
import AlertMessage from '../../components/modals/AlertMessage';
import DealerConnectModal from '../../components/modals/DealerConnectModal'
import DemoModal from '../../components/modals/DemoModal';
import ShareModal from '../../components/modals/ShareModal';
import MobMoreProducts from '../components/MobMoreProducts';
import MobRelatedProducts from '../components/MobRelatedProducts';

const MobProductDetails = () => {
    const url = window.location.href;

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    const currentUrl = window.location.href;
    const { dealerId } = useAuth()
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const [showShare, setShowShare] = useState(false);
    const [shareUrl, setShareUrl] = useState('');
    const [title, setTitle] = useState('');

    const [show, setShow] = useState(false);
    const [active, setActive] = useState();

    const [page, setPage] = useState(1)
    const [pages, setPages] = useState()
    const [loader, setLoader] = useState(false)
    const [demoToast, setDemoToast] = useState(false);


    const [data, setData] = useState("")
    const [relatedProducts, setRelatedProducts] = useState([]);
    const [moreProducts, setMoreProducts] = useState([]);
    const [banner, setBanner] = useState([])

    useEffect(() => {
        setBanner([])
        setLoader(true)
        var myHeaders = new Headers();
        myHeaders.append("wu-platform", "WUd2FsbGljb25Vc2VyOmFGVEhWUFIWAIMUser3RXJTUG92YjVtYjhzSHpvQTVfTEZyWXNU");
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "dealerId": dealerId,
            "itemNo": pathname.split('/').pop()
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(process.env.REACT_APP_URL + "customer/item", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === "success") {
                    setData(result.data)
                    setRelatedProducts(result.relatedProducts)
                    setMoreProducts(result.moreProducts)
                    setBanner(prevState => [
                        ...prevState,
                        {
                            style_name: "",
                            image: result.data.itemImgDetails.masterimg,
                        },
                        {
                            style_name: "",
                            image: result.data.itemImgDetails.productimg,
                        },
                        {
                            style_name: "",
                            image: result.data.itemImgDetails.closeupimg,
                        },
                    ])
                    result.data.itemImgDetails.stylesImgs.map(obj =>
                        setBanner(prevState => [
                            ...prevState,
                            {
                                style_name: obj.style_name,
                                image: obj.demoimg,
                            }
                        ]))

                    setPages(result.pages)
                    setLoader(false)
                }
            })
            .catch(error => console.log('error', error));
    }, [dealerId, pathname])

    const loadMore = () => {
        setPage(page + 1)
    }
    const [showToast, setShowToast] = useState(false);
    const [reqType, setReqType] = useState("");
    const { wished, setWished, removeWished, setRemoveWished, cart, setCart, removeCart, setRemoveCart, demo } = useAuth()

    // ---------------------------Wished Items------------------------
    const localWished = JSON.parse(localStorage.getItem("wished"))
    useEffect(() => {
        if (localWished && wished.length === 0) {
            if (removeWished === 0) {
                localStorage.removeItem("wished")
            } else {
                setWished(...wished, localWished)
            }
        }
        if (wished.length !== 0) {
            localStorage.setItem("wished", JSON.stringify(wished))
        }

    }, [wished, setWished, localWished, removeWished,])

    // ---------------------------Cart Items------------------------
    const localCart = JSON.parse(localStorage.getItem("cart"))
    useEffect(() => {
        if (localCart && cart.length === 0) {
            if (removeCart === 0) {
                localStorage.removeItem("cart")
            } else {
                setCart(...cart, localCart)
            }
        }
        if (cart.length !== 0) {
            localStorage.setItem("cart", JSON.stringify(cart))
        }

    }, [cart, setCart, localCart, removeCart,])

    return (
        <div className="mainWidth mx-2">
            <DealerConnectModal
                show={show}
                setShow={setShow}
            />
            <ShareModal
                show={showShare}
                setShowShare={() => setShowShare(false)}
                url={shareUrl}
                title={title}
            />
            <AlertMessage
                show={showToast}
                setShow={() => setShowToast(false)}
                reqType={reqType}
            />
            <DemoModal
                show={demoToast}
                setShow={setDemoToast}
            />

            {loader === true ? <div className="App-header">
                <img src="/assets/icons/wallicon.gif" alt="loader" />
            </div> :
                <Slider {...settings} arrows={false} className="productDots tw_center">
                    {banner && banner.map((item, index) => {
                        return (
                            <div key={index} className="position-relative">
                                <img
                                    src={process.env.REACT_APP_S3URL + item.image}
                                    alt={currentUrl.split('/').pop()}
                                    className="productDesImg"
                                />
                                <span className="style_name">
                                    {item.style_name}
                                </span>
                            </div>
                        );
                    })}
                </Slider>
            }

            <Row className="mx-0">
                <Col className="ps-0">
                    {/* {productDes.itemColor && productDes.itemColor.split(/,+/).map((item, index) => */}
                    {data.itemColor && data.itemColor.map((item, index) =>
                        <button
                            variant="secondary"
                            key={index}
                            className={`rounded-circle border-0 mobBtnCirlce me-3 ${index === active ? "btnCirlceActive" : ""}`}
                            onClick={() => setActive(index)}
                            style={{ background: item }}
                        />
                    )}
                </Col>
                <Col className="text-end pe-0">
                    <img
                        src={wished.find(obj => obj.itemNo === data.itemNo) ? "/assets/icons/wished.png" : "/assets/icons/wish.svg"}
                        alt="wish"
                        className=" me-2 mouse"
                        width="20"
                        height="22"
                        onClick={() => {
                            if (demo) {
                                setDemoToast(true)
                            }
                            else if (data.qty < 1) {
                                alert("This product is out of stock!")
                            }
                            else if (!dealerId) {
                                setShow(true)
                            } else if (wished.find(obj => obj.itemNo === data.itemNo)) {
                                if (wished.length === 1) {
                                    setRemoveWished(0)
                                    setReqType("removeWished")
                                }
                                const x = wished.indexOf(wished.find(obj => obj.itemNo === data.itemNo))
                                wished.splice(x, 1)
                                setWished([...wished])
                                setReqType("removeWished")
                            }
                            else if (cart.find(obj => obj.itemNo === data.itemNo)) {
                                if (cart.length === 1) {
                                    setRemoveCart(0)
                                    setWished([...wished, {
                                        cartType: data.cartType,
                                        itemNo: data.itemNo,
                                        masterimg: data.itemImgDetails.masterimg,
                                        metaTitle: data.metaTitle,
                                        price: data.price,
                                        product_name: data.product_name,
                                        collection_name: data.collection_name,
                                        qty: data.qty,
                                        title: data.title,
                                        unit: data.unit,
                                    }])
                                    setReqType("moveWished")
                                    setShowToast(true)
                                }
                                const x = cart.indexOf(cart.find(obj => obj.itemNo === data.itemNo))
                                cart.splice(x, 1)
                                setCart([...cart])
                                setWished([...wished, {
                                    cartType: data.cartType,
                                    itemNo: data.itemNo,
                                    masterimg: data.itemImgDetails.masterimg,
                                    metaTitle: data.metaTitle,
                                    price: data.price,
                                    product_name: data.product_name,
                                    collection_name: data.collection_name,
                                    qty: data.qty,
                                    title: data.title,
                                    unit: data.unit,
                                }])
                                setReqType("moveWished")
                                setShowToast(true)
                            }
                            else {
                                setWished([...wished, {
                                    cartType: data.cartType,
                                    itemNo: data.itemNo,
                                    masterimg: data.itemImgDetails.masterimg,
                                    metaTitle: data.metaTitle,
                                    price: data.price,
                                    product_name: data.product_name,
                                    collection_name: data.collection_name,
                                    qty: data.qty,
                                    title: data.title,
                                    unit: data.unit,
                                }])
                                setReqType("addWished")
                                setShowToast(true)
                            }
                        }}
                    />
                    <img
                        src="/assets/icons/share.png"
                        alt="share"
                        className=" mouse"
                        height="22"
                        width="22"
                        onClick={() => { setShowShare(true); setTitle(data.metaTitle); setShareUrl(url) }}
                    />
                </Col>
            </Row>
            <div className="fw-light ">
                <div className="fs16 ls20  pe-2 mp_text_length">
                    {data.title}
                </div>
                <Row className="w-100 mx-0  mt-1">
                    <Col xs={1} className="p-0">
                        <div className="priceText"> Price: </div>
                    </Col>
                    <Col xs={5} className="pe-0 ">
                        <div className="fw-bold fs18 priceText ls1em pe-0 mouse">
                            {!dealerId ? (
                                <>
                                    <div
                                        className="text-decoration-underline ms-1"
                                        onClick={() => {
                                            if (demo) {
                                                setDemoToast(true)
                                            }
                                            else {
                                                setShow(true)
                                            }
                                        }}
                                    >
                                        Check Price
                                    </div>
                                </>
                            ) : (
                                <span>&#8377;{data.price}/{data.unit}</span>
                            )}
                        </div>
                        <div className="mtN3 fs10 text-danger cpm">
                            {!dealerId
                                ? " *Click Here!"
                                : data.qty < 21
                                    ? "*Hurry up only 500 pcs left!"
                                    : null}
                        </div>
                    </Col>
                    <Col xs={6} className="p-0 tw_right">
                        <div className=" fw-light ">
                            {!dealerId ? (
                                <div
                                    className="text-decoration-underline mouse fs16"
                                    onClick={() => {
                                        if (demo) {
                                            setDemoToast(true)
                                        }
                                        else {
                                            setShow(true)
                                        }
                                    }}
                                >
                                    Check Free Installation
                                </div>
                            ) : (
                                <>
                                    <div className="fs_13">
                                        Free Installation Eligiblity
                                        <img
                                            src="/assets/icons/tick_mark.png"
                                            alt="tick_mark"
                                            className="ms-1"
                                            height="15"
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </Col>
                </Row>

                <Row className="my-3 cpm mx-0">
                    <Col className="ps-0">
                        <button disabled={data.qty < 1}
                            variant="outline-success"
                            className="bg-white outline-none border_clr text-dark  rounded fs_14 w_90 py-2"
                            onClick={() => {
                                if (demo) {
                                    setDemoToast(true)
                                }
                                else if (!dealerId) {
                                    setShow(true)
                                } else if (cart.find(obj => obj.itemNo === data.itemNo)) {
                                    navigate("/checkout/cart")
                                }
                                else if (wished.find(obj => obj.itemNo === data.itemNo)) {
                                    if (wished.length === 1) {
                                        setRemoveWished(0)
                                        setCart([...cart, {
                                            cartType: data.cartType,
                                            itemNo: data.itemNo,
                                            masterimg: data.itemImgDetails.masterimg,
                                            metaTitle: data.metaTitle,
                                            price: data.price,
                                            product_name: data.product_name,
                                            collection_name: data.collection_name,
                                            qty: data.qty,
                                            title: data.title,
                                            unit: data.unit,
                                        }])
                                        setReqType("moveCart")
                                        setShowToast(true)
                                    }
                                    const x = wished.indexOf(wished.find(obj => obj.itemNo === data.itemNo))
                                    wished.splice(x, 1)
                                    setWished([...wished])
                                    setCart([...cart, {
                                        cartType: data.cartType,
                                        itemNo: data.itemNo,
                                        masterimg: data.itemImgDetails.masterimg,
                                        metaTitle: data.metaTitle,
                                        price: data.price,
                                        product_name: data.product_name,
                                        collection_name: data.collection_name,
                                        qty: data.qty,
                                        title: data.title,
                                        unit: data.unit,
                                    }])
                                    setReqType("moveCart")
                                    setShowToast(true)
                                }
                                else {
                                    setCart([...cart, {
                                        cartType: data.cartType,
                                        itemNo: data.itemNo,
                                        masterimg: data.itemImgDetails.masterimg,
                                        metaTitle: data.metaTitle,
                                        price: data.price,
                                        product_name: data.product_name,
                                        collection_name: data.collection_name,
                                        qty: data.qty,
                                        title: data.title,
                                        unit: data.unit,
                                    }])
                                    setReqType("addCart")
                                    setShowToast(true)
                                }
                            }}
                        >
                            {
                                cart.find(obj => obj.itemNo === data.itemNo) ?
                                    "Go To Cart" : "Add To Cart"
                            }
                        </button>
                    </Col>
                    <Col className="p-0 text-end text-dark ">
                        <button disabled={data.qty < 1 && true}
                            type="submit"
                            className="bg_green_clr border_clr outline-none rounded fs_14 w_90 py-2 text-dark"
                            onClick={() => {
                                if (demo) {
                                    setDemoToast(true)
                                } else if (!dealerId) {
                                    setShow(true)
                                } else if (cart.find(obj => obj.itemNo === data.itemNo)) {
                                    navigate('/checkout/cart');
                                } else {
                                    setCart([...cart, {
                                        cartType: data.cartType,
                                        itemNo: data.itemNo,
                                        masterimg: data.itemImgDetails.masterimg,
                                        metaTitle: data.metaTitle,
                                        price: data.price,
                                        product_name: data.product_name,
                                        collection_name: data.collection_name,
                                        qty: data.qty,
                                        title: data.title,
                                        unit: data.unit,
                                    }])
                                    navigate('/checkout/cart');
                                }
                            }}
                        >
                            Proceed To Order
                        </button>
                    </Col>
                </Row>
                <div className="Qty_Dealer">Specifications</div>
                <Table bordered size="sm" className=" fs11">
                    <tbody>
                        <tr>
                            <td>Pattern Number</td>
                            <td>{data.itemNo}</td>
                        </tr>
                        <tr>
                            <td>Size</td>
                            <td>{data.itemSize}</td>
                        </tr>
                        <tr>
                            <td>Product Color</td>
                            <td>{data.itemColor}</td>
                        </tr>
                        <tr>
                            <td>Style</td>
                            <td>{banner && banner.map((item, index) => item.style_name === '' || item.style_name === "undefined" ?
                                null : <span key={index} className="mouse" > {item.style_name}{index === 0 ? "" : ","} </span>)}</td>
                        </tr>
                        <tr>
                            <td>Type</td>
                            <td>{data.type_name}</td>
                        </tr>
                    </tbody>
                </Table>

                <div className="Qty_Dealer">Description</div>
                <div className="fs12 ls15 muted_clr flex-wrap mb-3">
                    {data.description}
                </div>
                {/* <div className="Qty_Dealer mb-1">Order Overview Video</div>

                <iframe className="w-100 br_10 videoTab" src="https://www.youtube-nocookie.com/embed/byBWE8l7Y3k?controls=0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /> */}

                {/* {data.faqs.length > 0 && <div className="fs16 mt-2">Frequently Asked Questions (FAQ)</div>} */}

                {data.faqs && data.faqs.map((item, index) =>
                    <Accordion key={index} className="">
                        <Accordion.Item className="border-0 p-0 " eventKey="0">
                            <Accordion.Header className="border-0 text-decoration-none p-0 accordion_btn muted_clr1 bg-transparent">
                                <div className="fs14 cpm px-0 ">{item.question}</div>
                            </Accordion.Header>
                            <Accordion.Body className="border-0 px-2 py-0 fs14">
                                {item.answer}
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                )}
            </div>

            {loader === true ?
                <div className="moreDataLoader">
                    <img src="/assets/icons/wallicon.gif" alt="loader" />
                </div>
                :
                <MobRelatedProducts data={relatedProducts} />
            }
            {loader === true ?
                <div className="moreDataLoader">
                    <img src="/assets/icons/wallicon.gif" alt="loader" />
                </div>
                :
                <>
                    <h4 className="text-center mt-2 cpm">More Designs of {data.product_name}</h4>
                    <MobMoreProducts loadMore={loadMore} page={page} pages={pages} setPage={setPage} data={moreProducts} />
                </>
            }
        </div>
    )
}

export default MobProductDetails